import PercentLogo from '~/assets/drill/percent'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function Percent({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-5 row-end-7 col-start-1 col-end-3'
  const gridTablet = 'md:row-start-1 md:row-end-1 md:col-start-5 md:col-end-7'
  const gridDesktop = 'xl:row-start-1 xl:row-end-1 xl:col-start-5 xl:col-end-7'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={PercentLogo}
      imageClassNames="h-16"
      path={path}
      title={title}
    />
  )
}
